import type { CombinedError } from '@urql/vue';

import type { MmaSessionFragmentFragment } from '~/graphql/mma/generated/graphql';

interface MmaBaseUserStatus {
  fetching?: boolean,
  error?: CombinedError,
  data?: MmaSessionFragmentFragment | null,
}
export const useMmaBaseUserStatus = () => useState<MmaBaseUserStatus>('mma-base-user-status', () => ({
  fetching: undefined,
  error: undefined,
  data: undefined,
}));
